import { BaseModel } from '../base-model';

export interface IDemandDescHtml {
  IconUrl?: string;
  Color?: string;
  NameNL?: string;
  NameEN?: string;
  NameFR?: string;
}
export class DemandDescHtml extends BaseModel<IDemandDescHtml> implements IDemandDescHtml {
  IconUrl: string;
  Color: string;
  NameNL: string;
  NameEN: string;
  NameFR: string;
  /**
   *
   */
  constructor(option?: IDemandDescHtml) {
    super(option);
  }
}